<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content fxLayout="column">
  <p>{{data.message}}</p>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="center">
  <button mat-button [mat-dialog-close]="true">Oui</button>
  <button mat-button [mat-dialog-close]="false">Non</button>
</mat-dialog-actions>
